module.exports = __webpack_public_path__ + "media/images/front/home/certificados-0cd42d1ef0ca0f8127a67be300811382.jpg";